import { Edit, RefreshButton, SaveButton, useForm } from '@refinedev/antd';

import ProtectedDeleteButton from '@/components/protected/ProtectedDeleteButton';
import { Shipper } from '@/model/Logistic/Shipper/Shipper';

import ShipperForm from './ShipperForm/ShipperForm';

export const ShipperEdit = () => {
  const { formProps, saveButtonProps, query } = useForm<Shipper>();

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={query?.isLoading || query?.isFetching}
      footerButtons={({ deleteButtonProps }) => (
        <>
          <ProtectedDeleteButton {...deleteButtonProps} />
          <SaveButton {...saveButtonProps} />
        </>
      )}
      headerButtons={({ refreshButtonProps }) => <RefreshButton {...refreshButtonProps} />}>
      {query?.data && <ShipperForm formProps={formProps} edit />}
    </Edit>
  );
};

export default ShipperEdit;
